import RoutesConstants from '../../shared-components/Routes/routes.constants';
import { useNavigate } from 'react-router-dom';
import React, { useEffect, useState } from 'react'
// import PaymentCard from './PaymentCard';
import { observer } from 'mobx-react';
import PaymentPage from './PaymentPage';
import { ProductType } from '../../constants/enum';
import { useStore } from '../../contexts/StoreProvider';

const TrainerDashboardPayment = () => {
      const { adminStore } = useStore();
    const { getPaymentSetting, allPaymentSettingInfo } = adminStore;

     useEffect(() => {
        getPaymentSetting();
    }, []);

    const getRenewAmount = () => {

        if (allPaymentSettingInfo.length === 0) return undefined;

        const setting = allPaymentSettingInfo.find(
            s => s.ProductType === ProductType.TrainerPlanRenew
        );

        if (!setting) return undefined;
            return setting.JPY;
    }
     const amount = getRenewAmount();

    if (!amount) return null;
    return <PaymentPage productType={ProductType.TrainerPlanRenew} amount={amount}/>
}
export default observer(TrainerDashboardPayment);